import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TransferMoney from '../component/TransferMoneyV2';
import actions from '../redux/actions/transactions';
import settingAction from '../redux/actions/setting_data';

const mapStateToProps = (state) => ({
  coins: state.setting.coins,
  mapUserBalance: state.admin.mapBalances,
  admin: state.admin,
  transaction: state.transaction,
  settings: state.setting.coinSettings,
  session: state.user.session,
  limits: state.setting.limitWithdrawals,
  mapLimitWithdrawals: state.setting.mapLimitWithdrawals,
  currencyMarkets: state.setting.currencyMarkets,
  limit24h: state.admin.limit24h,
});

const mapDispatchToProps = (dispatch) => ({
  onWithdrawal: (params, callback) => {
    dispatch(actions.onWithdrawal(params, callback));
  },
  onFetchTransactionHistory: (params) => {
    dispatch(actions.onFetchTransactionHistory(params));
  },
  fetchUserVolume24hAction: (params, callback) => {
    dispatch(actions.fetchUserVolume24hAction(params, callback));
  },
  fetchLimitWithdrawalAction: (params) => {
    dispatch(settingAction.fetchLimitWithdrawalAction(params));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TransferMoney));
